export default "__VITE_ASSET__C9eVf2he__"